import { Component, OnInit } from '@angular/core';
import { Veroispovest } from './veroispovest';
import { BaseModalContainer, ModalContainerService, ModalService, UserService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'yt-veroispovest',
  templateUrl: './veroispovest.component.html'
})
export class VeroispovestComponent extends BaseModalContainer<Veroispovest> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<Veroispovest>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected userService: UserService
  ) {
    super(modalContainerService, activatedRoute, modalService, userService);
   }

  ngOnInit() {
  }

}
